export default "__VITE_ASSET__CfmqIXoY__"